import fetcher from 'api/fetcher';
import { formatDate } from 'utils/date';

import urlParser from 'bloko/common/urlParser';

import { setInvoices, setLoadInvoices } from 'store/models/manualCharges';

export default () => {
    return (dispatch, getState) => {
        const { from, to } = getState().manualCharges;
        dispatch(setLoadInvoices(true));
        const queryStr = urlParser.stringify({
            dateFrom: formatDate(from),
            dateTo: formatDate(to),
        });
        return fetcher
            .get(`/api/v1/backoffice/invoices/manual?${queryStr}`)
            .then((invoices) => {
                dispatch([setInvoices(invoices), setLoadInvoices(false)]);
            })
            .catch(() => {
                dispatch([setInvoices([]), setLoadInvoices(false)]);
            });
    };
};
